import { useNavigate } from "react-router-dom";
import styles from "./PracticeAreas.module.css";
import PageBanner from "../components/PageBanner";
import servicesBanner from "../assets/3.png";
import CustomTitle from "../components/CustomTitle";
import { SiRundeck } from "react-icons/si";
import icon8 from "../assets/icons/Therapeutic.png";
import icon3 from "../assets/icons/compliance.png";
import icon1 from "../assets/icons/agreement.png";
import icon2 from "../assets/icons/forest1.png";
import icon4 from "../assets/icons/tribunals.png";
import icon5 from "../assets/icons/mediation.png";
import icon6 from "../assets/icons/counselling.png";
import icon7 from "../assets/icons/abuse.png";
import icon9 from "../assets/icons/property.png";
import icon10 from "../assets/icons/Consumercomplaints.png";
import icon11 from "../assets/icons/Contractenforcement.png";
import icon12 from "../assets/icons/Defamationandtort.png";
import icon13 from "../assets/icons/Whitecollar.png";
import icon17 from "../assets/icons/1.png";
import icon15 from "../assets/icons/7.png";
import icon26 from "../assets/icons/2.png";
import icon27 from "../assets/icons/8.png";
import icon30 from "../assets/icons/6.png";
import icon28 from "../assets/icons/9.png";
import icon16 from "../assets/icons/child.png";
import icon18 from "../assets/icons/13.png";
import icon19 from "../assets/icons/matri.png";
import icon20 from "../assets/icons/15.png";
import icon40 from "../assets/icons/businessminimize.png";
import icon39 from "../assets/icons/exchangecompliance.png";
import icon36 from "../assets/icons/fostering.png";
import { title } from "framer-motion/client";
//import LocationFooter from "./LocationFooter";
const services = [
  {
    title: "Commercial & Corporate Law.",
    name: "corporate",
    description:
      "Comprehensive legal solutions for business: contracts, M&A, dispute resolution, and regulatory compliance.",

    points: [
      { icon: icon17, text: "Contract drafting and negotiation." },
      {
        icon: icon18,
        text: "Corporate governance.",
      },
      { icon: icon26, text: "Joint ventures and partnerships." },
      { icon: icon27, text: "Arbitration and dispute resolution." },
    ],
  },
  {
    title: "Labor & Employment Law",
    name: "labor",
    description:
      "We advise employers and employees on the full spectrum of labor and employment law issues.",
    points: [
      {
        icon: icon1,
        text: "organizational needs with employee rights",
      },
      {
        icon: icon36,
        text: "fostering a compliant workplace.",
      },
      { icon: icon6, text: "harmonious workplace environment." },
      {
        icon: icon3,
        text: "compliance with labor welfare legislations",
      },
    ],
  },
  {
    title: "Civil Law.",
    name: "civil",
    description:
      "We handle all civil disputes with legal precision — including property conflicts, contract enforcement, and tort litigation.",

    points: [
      { icon: icon9, text: "Property and land disputes." },
      {
        icon: icon10,
        text: "Consumer complaints.",
      },
      { icon: icon11, text: "Contract enforcement." },
    ],
  },
  {
    title: "Criminal Law.",
    name: "criminal",
    description:
      "Expert defense in white-collar crimes, cybercrime, NDPS, and more — safeguarding your rights through every legal stage.",

    points: [
      { icon: icon13, text: "White-collar crimes." },

      { icon: icon15, text: "Cybercrimes." },
    ],
  },
];
const specialservices = [
  {
    title: "Mining Law",
    name: "mining",
    description:
      "We offer expert counsel to mining operators and contractors on lease acquisition, regulatory compliance, and environmental clearances.",

    points: [
      { icon: icon1, text: "Mining lease agreements." },
      { icon: icon4, text: "Representation before tribunals" },
      { icon: icon28, text: "Legal audits and compliance" },
      { icon: icon2, text: "MMDR, EIA, and Forest Act guidance" },
    ],
  },
  {
    title: "Matrimonial Counselling & Mediation",
    name: "civil",
    description:
      "We blend legal knowledge with empathetic counselling to resolve disputes and offer dignified separation support.",

    points: [
      { icon: icon5, text: "Pre-litigation mediation." },
      {
        icon: icon7,
        text: "Legal guidance on domestic abuse",
      },
      { icon: icon6, text: "Reconciliation counselling" },
      { icon: icon8, text: "Therapeutic consultations" },
    ],
  },

  {
    title: "Family Law",
    name: "family",
    description:
      "Legal support for families with a focus on dignity, protection, and justice in sensitive matters.",

    points: [
      { icon: icon19, text: "Matrimonial disputes & divorce." },
      {
        icon: icon16,
        text: "Child custody & guardianship.",
      },
      { icon: icon20, text: "Inheritance and succession." },
      { icon: icon30, text: "Assault, theft, and homicide" },
    ],
  },
  {
    title: "Regulatory Compliance",
    name: "regulatory",
    description:
      "Navigating India’s complex regulatory environment requires precision and foresight.",

    points: [
      { icon: icon19, text: "resolving regulatory disputes." },
      { icon: icon39, text: "securities and exchange compliance." },
      { icon: icon15, text: "foreign direct investment." },
      { icon: icon40, text: "helps in business minimize risk." },
    ],
  },
];
const PracticeAreas = () => {
  const navigate = useNavigate();
  return (
    <>
      <PageBanner image={servicesBanner} title="Our Services" />
      <section className={styles.services}>
        <CustomTitle>Our Practice Areas</CustomTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div>
            <h2>Specialized Practice Areas</h2>
          </div>
          <div>
            <SiRundeck
              color="#ffcd38"
              size={18}
              style={{ marginTop: "30px", marginLeft: "10px" }}
            />
          </div>
        </div>

        <div className={styles.servicesList}>
          {specialservices.map((srv, idx) => (
            <div
              key={idx}
              className={styles.serviceCard}
              onClick={() => navigate(`/${srv.name}`)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div>
                  <h3>{srv.title}</h3>
                </div>
                <div>
                  <SiRundeck
                    color="#ffcd38"
                    size={18}
                    style={{ marginTop: "25px", marginLeft: "10px" }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    alignContent: "center",
                  }}
                >
                  <p>{srv.description}</p>
                </div>
                <div
                  style={{
                    alignItems: "center",
                  }}
                >
                  <ul className={styles.servicePoints}>
                    {srv.points.map((point, i) => (
                      <li key={i}>
                        <img
                          src={point.icon}
                          alt="bullet icon"
                          className={styles.bulletImg}
                        />

                        <span> {point.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <div>
            <h2>Other Practice Areas</h2>
          </div>
          <div>
            <SiRundeck
              color="#ffcd38"
              size={18}
              style={{ marginTop: "30px", marginLeft: "10px" }}
            />
          </div>
        </div>
        <div className={styles.servicesList}>
          {services.map((srv, idx) => (
            <div
              key={idx}
              className={styles.serviceCard}
              onClick={() => navigate(`/${srv.name}`)}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <div>
                  <h3>{srv.title}</h3>
                </div>
                <div>
                  <SiRundeck
                    color="#ffcd38"
                    size={18}
                    style={{ marginTop: "25px", marginLeft: "10px" }}
                  />
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    alignContent: "center",
                  }}
                >
                  <p>{srv.description}</p>
                </div>
                <div
                  style={{
                    alignItems: "center",
                  }}
                >
                  <ul className={styles.servicePoints}>
                    {srv.points.map((point, i) => (
                      <li key={i}>
                        <img
                          src={point.icon}
                          alt="bullet icon"
                          className={styles.bulletImg}
                        />

                        <span> {point.text}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
      {/*    <LocationFooter /> */}
    </>
  );
};

export default PracticeAreas;
